import { useInfiniteQuery, useMutation, useQuery } from 'react-query';

import {
  createCustomerCategory,
  getCustomerCategory,
  getListCustomerCategory,
  removeCustomerCategory,
  updateCustomerCategory,
} from './CustomerCategory.service';

import { notification } from 'antd';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';
import { ListCustomersCategoryQuery } from './CustomerCategory.types';
import { PageRequest } from '@/core/request/PageRequest';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';

export function useCustomerCategoryList(
  params?: ListCustomersCategoryQuery,
  enabled = true,
) {
  const cache = queryClient.getQueryData([
    'customers/categories',
    { ...params },
  ]);

  return useInfiniteQuery(
    ['customers/categories', { ...params }],
    ({ pageParam }) => {
      const req: PageRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return getListCustomerCategory(req);
    },
    {
      enabled: enabled && !cache,
      getNextPageParam: (lastPage) => lastPage.nextToken,
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function useCustomerCategoryDetails(id?: number) {
  return useQuery(
    ['customer-category-details', id],
    () => getCustomerCategory(id),
    {
      enabled: !!id,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useCustomerCategoryCreate() {
  const queryChanel = useQueryChanel();

  return useMutation(createCustomerCategory, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Categoria de cliente criada com sucesso!',
      });

      queryChanel({
        invalidateQueries: [['customers/categories']],
        refetchQueries: [['customers/categories']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useCustomerCategoryUpdate() {
  const queryChanel = useQueryChanel();

  return useMutation(updateCustomerCategory, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Categoria de cliente editada com sucesso!',
      });

      queryChanel({
        invalidateQueries: [['customers/categories']],
        refetchQueries: [['customers/categories']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useCustomerCategoryRemove() {
  const queryChanel = useQueryChanel();

  return useMutation(removeCustomerCategory, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Categoria de cliente removida com sucesso!',
      });

      queryChanel({
        invalidateQueries: [['customers/categories']],
        refetchQueries: [['customers/categories']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
